import { render, staticRenderFns } from "./problemDetails.vue?vue&type=template&id=1a86902b&scoped=true&"
import script from "./problemDetails.vue?vue&type=script&lang=js&"
export * from "./problemDetails.vue?vue&type=script&lang=js&"
import style0 from "./problemDetails.vue?vue&type=style&index=0&id=1a86902b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a86902b",
  null
  
)

export default component.exports